import { BlendedCourse, ClassCourse, Occurrence } from '@shared/types';
import { ButtonAnchor, ButtonLink } from 'components/_ui/Buttons';
import { FunctionComponent, useMemo } from 'react';
import { getBookUrl } from '../../../../services/getBookUrl';
import { useAppSelector } from 'store';

type BookButtonProps = {
    child: Occurrence;
    course: ClassCourse | BlendedCourse;
    isDisabled: boolean;
    educatorSlug: string;
    embedded: boolean;
    listParam: string;
    isSoldOut: boolean;
};

export const BookButton: FunctionComponent<BookButtonProps> = ({
    course,
    isDisabled,
    educatorSlug,
    embedded,
    isSoldOut,
    listParam,
    child,
}) => {
    const { utmsQueryString, parentWindowUrl } = useAppSelector(
        (store) => store.profile.utm_details
    );

    const buttonLabel: string = useMemo(
        () => (isSoldOut ? 'Sold out' : 'Book Session'),
        [isSoldOut]
    );
    const bookingLink: string = useMemo(() => {
        return getBookUrl(
            course.slug,
            educatorSlug,
            child._id,
            embedded,
            parentWindowUrl,
            utmsQueryString,
            listParam,
            course.application_required
        );
    }, [
        child._id,
        course.application_required,
        course.slug,
        educatorSlug,
        embedded,
        listParam,
        utmsQueryString,
        parentWindowUrl,
    ]);

    if (embedded) {
        return (
            <ButtonAnchor
                href={isDisabled ? '#' : bookingLink}
                size="sm"
                margin="0 0 0 auto"
                appearance="outlined"
            >
                {buttonLabel}
            </ButtonAnchor>
        );
    }

    return (
        <ButtonLink
            to={getBookUrl(
                course.slug,
                educatorSlug,
                child._id,
                embedded,
                parentWindowUrl,
                utmsQueryString,
                listParam,
                course.application_required
            )}
            size="sm"
            margin="0 0 0 auto"
            appearance="outlined"
            disabled={isDisabled}
        >
            {buttonLabel}
        </ButtonLink>
    );
};
